interface TextareaMentionHandlerLike {
    handleInputLike(event?: Event): void;
    handleKeyDown(event: KeyboardEvent): void;
    handleDropdownMouseDown(event: MouseEvent): void;
    handleDocumentMouseDown(event: MouseEvent): void;
}

export class TextareaMentionListener {
    public static bindContentInserted(onInserted: (root: ParentNode) => void): void {
        document.addEventListener("app:content:inserted", (event: Event) => {
            if (event instanceof CustomEvent && event.detail?.root instanceof HTMLElement) {
                onInserted(event.detail.root as HTMLElement);
            }
        });
    }

    public static bind(
        textarea: HTMLTextAreaElement,
        dropdownEl: HTMLElement,
        handler: TextareaMentionHandlerLike,
    ): void {
        textarea.addEventListener("keydown", (event: Event) => {
            if (event instanceof KeyboardEvent) {
                handler.handleKeyDown(event);
            }
        });
        textarea.addEventListener("input", (event: Event) => handler.handleInputLike(event));
        textarea.addEventListener("click", (event: Event) => handler.handleInputLike(event));
        dropdownEl.addEventListener("mousedown", (event: Event) => {
            if (event instanceof MouseEvent) {
                handler.handleDropdownMouseDown(event);
            }
        });
        document.addEventListener(
            "mousedown",
            (event: Event) => {
                if (event instanceof MouseEvent) {
                    handler.handleDocumentMouseDown(event);
                }
            },
            true,
        );
    }
}
